/** Image de secours affichée quand une cover API est absente ou en erreur. */
export const EMPTY_COVER_PLACEHOLDER: string = '/images/emptyCoverPicture.png'
